var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Exit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: 52,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.34375 0 3 1.34375 3 3L3 23C3 24.65625 4.34375 26 6 26L20 26C21.65625 26 23 24.65625 23 23L23 17.8125L21 19.5625L21 23C21 23.550781 20.550781 24 20 24L6 24C5.449219 24 5 23.550781 5 23L5 3C5 2.449219 5.449219 2 6 2L20 2C20.550781 2 21 2.449219 21 3L21 6.4375L23 8.1875L23 3C23 1.34375 21.65625 0 20 0 Z M 16.5 6.46875C16.25 6.542969 16 6.796875 16 7.46875L16 10L10 10C9.449219 10 9 10.449219 9 11L9 15C9 15.550781 9.449219 16 10 16L16 16L16 18.5C16 19.78125 17 19.5 17 19.5L24.5 13L17 6.5C17 6.5 16.75 6.394531 16.5 6.46875Z",
    fill: "#26260D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Exit);
export default __webpack_public_path__ + "static/media/icons8_exit.5bd21c76fb4b31d76a3d38e8c5eee17f.svg";
export { ForwardRef as ReactComponent };